'use client'

import { Button } from '@nextui-org/react'
import { ShoppingCart } from 'lucide-react'
import { useLocale } from 'next-intl'
import { useState } from 'react'

import { env } from '@/constants/configs'
import { Link } from '@/libs/intl'

interface CartButtonProps {
  className?: string
  iconClassName?: string
  initialCount?: number
}

export function CartButton({
  className,
  iconClassName = 'size-5 text-theme',
  initialCount = 0
}: CartButtonProps) {
  const locale = useLocale()
  const baseUrl = env.API_GATEWAY || 'https://dev.oasisspa.net'
  const cartUrl = `${baseUrl}/${locale === 'th' ? 'th' : 'en'}/onlinegift/cart/`
  const [cartCount, setCartCount] = useState<number>(initialCount)

  const shouldShowBadge = cartCount > 0
  const badgeValue = cartCount > 99 ? '99+' : cartCount

  return (
    <Button
      as={Link}
      href={cartUrl}
      className={`bg-transparent ${className || ''}`}
      radius='sm'
      size='md'
      isIconOnly
      aria-label='Menu shopping cart'>
      <div className='relative'>
        <ShoppingCart className={iconClassName} />
        {shouldShowBadge && badgeValue && (
          <span className='pointer-events-none absolute -right-2 -top-2 flex min-h-4 min-w-4 items-center justify-center rounded-full bg-theme px-1 text-[10px] font-semibold text-white'>
            {badgeValue}
          </span>
        )}
      </div>
    </Button>
  )
}
